<div class='row row--valign-center'>
  <div class='column--8'>
    <h3>Upload Courier Invoice</h3>
  </div>
  <div class='column--4 align-right'>
    <button mat-icon-button color='primary' (click)='dismissDrawer()'><mat-icon>close</mat-icon></button>
  </div>
</div>
<form [formGroup]="form">
  <div class='row'>
    <div class='column--12'>
      <mat-form-field class='full-width'>
        <mat-label>Courier</mat-label>
        <mat-select formControlName="provider" name='provider' placeholder='Select a courier'>
          <mat-option *ngFor='let option of issuerOptions[0].options' value="{{ option.id }}">{{ option.text }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>

  <div class='row' *ngIf='!isMultiFileMode'>
    <div class='column--12'>
      <mat-form-field class='full-width'>
        <mat-label>Invoice Number</mat-label>
        <input
          matInput
          formControlName='invoiceNumber'
          name='invoiceNumber'
        >
      </mat-form-field>
    </div>
  </div>

  <div class='row' *ngIf='isMultiFileMode'>
    <div class='column--12'>
      <span class='text--sm text--gray-dark'>Invoice number is taken from each file's BillID</span>
    </div>
  </div>

  <div class='row'>
    <div class='column--12'>
      <file-upload
        [fileFormControl]="form.get('file')"
        [buttonLabel]="'Upload invoice'"
        [multiple]='isMultiFileMode'
        (uploadedFileEvent)='updateUploadedFiles($event)'
      ></file-upload>
      <div *ngIf='isMultiFileMode' class='mt--sm'>
        <span class='text--sm text--gray-dark'>Up to 10 CSV files, 40 MiB total</span>
      </div>
    </div>
  </div>
</form>

<div class='row mt--sm' *ngIf='duplicateWarnings.length > 0'>
  <div class='column--12'>
    <div *ngFor='let warning of duplicateWarnings' class='mb--sm'>
      <div class='text--sm'><strong>{{ warning.originalFileName }}</strong></div>
      <div class='text--sm' style='color: #dc3545;' *ngFor='let entry of warning.entries'>
        {{ getDuplicateEntryMessage(entry) }}
      </div>
      <button
        *ngIf='warning.canUploadAnyway'
        mat-button
        color='primary'
        class='mdc-small-button'
        [disabled]='loading'
        (click)='uploadAnyway(warning)'
      >
        Upload anyway
      </button>
    </div>
  </div>
</div>

<div *ngIf='!loading, else isLoading'></div>

<div class='row mt--md'>
  <div class='column--6'>
    <button mat-flat-button color='accent' (click)='dismissDrawer()'>Cancel</button>
  </div>
  <div class='column--6 align-right'>
    <button mat-flat-button color='primary' (click)='submitForm()' [disabled]='form.invalid || loading'>Save</button>
  </div>
</div>
<ng-template #isLoading>
  <div class='align-center mt--lg'>
    <app-loading></app-loading>
  </div>
</ng-template>
